(ns common.sentry
  (:require ["@sentry/react" :as Sentry]))

(defn init-sentry []
  (let [env (.-__LEMONPI_ENV__ js/window)
        release (.-__LEMONPI_RELEASE_VERSION__ js/window)
        dsn "https://486bb9101a1b47e8a453f7dcf996451a@sentry.lemonpi.io/32"]
    ;; Disable on localhost (local) and development env.
    ;; Sentry (by default) wraps console.log, XHR etc. and
    ;; that messes up location information in JS console.
    (when-not (#{"development" "local"} env)
      (.init ^js Sentry #js {:dsn dsn
                             :release release
                             :environment env}))))
